import { createRouter, createWebHashHistory } from 'vue-router'

const List = () => import('@/views/ListView')
const Detail = () => import('@/views/DetailView')


const routes = [
  {
    path: '/',
    name: 'List',
    component: List
  },
  {
    path: '/show/:id',
    name: 'Detail',
    component: Detail
  },
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  scrollBehavior ()
  {
    // always scroll to top
    return { top: 0 }
  },
})

export default router
